import { createContext, useContext } from 'react';

export type LoaderState = {
  message: string;
  isLoading?: boolean;
};

export const initialState: LoaderState = {
  message: '',
  isLoading: false,
};

export type LoaderAction =
  | { type: 'startLoader'; payload: { message: string } }
  | { type: 'stopLoader' };

export type LoaderDispatch = (action: LoaderAction) => void;

export function loaderReducer(state: LoaderState, action: LoaderAction) {
  switch (action.type) {
    case 'startLoader': {
      return { message: action.payload.message, isLoading: true };
    }
    case 'stopLoader': {
      return initialState;
    }
    default: {
      // @ts-expect-error this should error if wrong type is thrown
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

export const LoaderContext = createContext<
  { state: LoaderState; dispatch: LoaderDispatch } | undefined
>(undefined);

export function useLoader() {
  const context = useContext(LoaderContext);
  if (context === undefined) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
}
